import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonUiModule } from '@awp/common';
import { ContentModule } from '@awp/content';
import { DynamicOutletModule } from '@awp/dynamic-outlet';

import { COMPONENTS } from './components';

@NgModule({
  imports: [
    RouterModule,
    CommonUiModule,
    ContentModule,
    DynamicOutletModule
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class LayoutModule { }
